export default (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_ZOOM_CONTEXT':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
